<template>
  <div class="langheader">
    <div class="con-width">
      <Row type="flex" class="top-row-bg">
        <router-link :to="{path: '/'}"></router-link>
        <Col class="mobilelogo" :xs="10" :sm="6" :md="10" :lg="4">
        <router-link :to="{path: '/'}"><img src="@/assets/logo.png" /></router-link>

        <router-link :to="{path: '/'}">
          <span>姓名图谱</span>
        </router-link>
        </Col>
        <Col :xs="4" :sm="2" :md="3" :lg="2">
        <router-link :to="{path: '/'}">首页</router-link>
        </Col>
        <Col :xs="4" :sm="2" :md="3" :lg="2">
        <router-link :to="{path: '/artical'}">文章</router-link>
        </Col>
        <Col :xs="4" :sm="2" :md="3" :lg="2">
        <router-link :to="{path: '/about'}">关于</router-link>
        </Col>
        <Col class="mobileName" :xs="4" :sm="3" :md="3" :lg="2">
        <router-link :to="{path: '/contact'}">联系</router-link>
        </Col>
        <Col :xs="8" :sm="2" :md="2" :lg="2" class="ptlashlogin">
        <!-- <span v-if="!$store.getters.user" class="ptlash" @click="login()">登录</span> -->
        <Dropdown v-if="$store.getters.user">
          <a href="javascript:void(0)">
            {{$store.getters.user.user_name}}
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem><router-link :to="{path: '/personalCenter'}">个人中心</router-link></DropdownItem>
            <DropdownItem>
              <p @click="handleLogout()">退出</p>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <router-link :to="{path: '/'}"><img src="@/assets/logo.png" /></router-link>
        </Col>
      </Row>
      <Modal title="登录" v-model="loginClick" class-name="ivu-modal-wrap" footer-hide>
        <Form ref="loginForm" autoComplete="on" :model="loginForm" class="card-box login-form">
          <Form-item prop="name">
            <Input type="text" v-model="loginForm.name" placeholder="手机号" autoComplete="on">
            <Icon type="md-person" slot="prepend"></Icon>
            </Input>
          </Form-item>
          <Form-item prop="password">
            <Input type="password" v-model="loginForm.password" placeholder="密码">
            <Icon type="md-lock" slot="prepend"></Icon>
            </Input>
          </Form-item>
          <!-- <Form-item prop="vcode" v-else="mobile">
            <Input type="number" style="width:60%; float:left;" v-model="loginForm.vcode" placeholder="验证码" @keyup.enter.native="handleLogin">

            <Icon type="md-lock" slot="prepend"></Icon>
            </Input>
            <Button type="primary" :disabled="vDisabled" class="sendMa" @click="sendMa">{{vtext}}</Button>
          </Form-item> -->
          <Form-item>
            <Button type="primary" @click="handleLogin()" long>登录</Button>
            <!-- <Button type="primary" v-else="mobile" :disabled="click" @click="vcodeLogin('loginForm')" long>登录</Button> -->
          </Form-item>
        </Form>
      </Modal>
    </div>

  </div>
</template>

<script>
import { telCheck } from "@/utils/validate";
export default {
  data() {
    const validatetel = (rule, value, callback) => {
      if (!telCheck(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("密码不能小于6位"));
      } else {
        callback();
      }
    };
    // const validateVcode = (rule, value, callback) => {
    //   if (value.length < 6) {
    //     callback(new Error("验证码不能小于6位"));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      loginClick: false,
      loginForm: {
        name: "13552675307",
        password: "123456"
        // vcode: ""
      },
      loginRules: {
        name: [{ required: true, trigger: "blur", validator: validatetel }],
        password: [{ required: true, trigger: "blur", validator: validatePass }]
        // vcode: [{ required: true, trigger: "blur", validator: validateVcode }]
      }
    };
  },
  mounted(){
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          let param = {
            type: "password",
            phone: this.loginForm.name,
            password: this.loginForm.password
          };
          this.loginLink(param);
        }
      });
    },
    login() {
      this.loginClick = true;
    },
    loginLink(data) {
      this.$store.dispatch("Login", data).then(res => {
        if (res.errcode == 200) {
          this.loginClick = false;
          this.$Message.success("登录成功");
          this.$store
            .dispatch("GetuserInfo")
            .then(res => {
              console.log(res)
            })
            .catch(error => {
              this.$Message.error(error.message);
            });
        } else if (res.errcode == 40001) {
          this.$Message.warning(res.errmsg);
        } else {
          this.$Message.warning(res.errmsg);
        }
      });
    },
    handleLogout() {
      this.$store
        .dispatch("Logout")
        .then(res => {
          this.$Message.success("退出成功");
          
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.langheader {
  .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    .ivu-modal {
      top: 0;
    }
  }
  .ivu-modal-body {
    padding: 34px 80px;
  }
  position: fixed;
  z-index: 100;
  top: 0;
  margin: 0 auto;
  width: 100%;
  height: 70px;
  background-color: #f8f8fa;
  border: 1px #fff solid;
  border-top: 4px solid rgb(0, 210, 165);
  box-shadow: 0 1px 3px #ddd;
  line-height: 70px;
  padding: 0 5px;
  // .link-web {
  //   color:rgb(37, 30, 37);
  // }
  .con-width {
    width: 1200px;
    margin: 0 auto;
    @media screen and (max-width: 1200px) {
      width: 100%;
    }
  }
  .top-row-bg {
    .mobilelogo {
      @media screen and (max-width: 1200px) {
        display: none;
      }
    }

    img {
      height: 50px;
      width: 50px;
      vertical-align: middle;
    }
    .ptlashlogin {
      text-align: right;
      img {
        @media screen and (min-width: 1200px) {
          display: none;
        }
        height: 40px;
        width: 40px;
        vertical-align: middle;
      }
    }
    .ptlash {
      font-size: 15px;
      margin-left: 0px;
    }
    span {
      display: inline-block;
      margin-left: 10px;
      font-size: 20px;
      @media screen and (max-width: 1200px) {
        font-size: 18px;
      }
      color: rgb(0, 210, 165);
    }
    .mobileName {
      display: none;
      @media screen and (max-width: 1200px) {
        display: block;
      }
    }
  }
}
</style>
